var NRDashboardPresenter = /** @class */ (function () {
    function NRDashboardPresenter(nrDashboradUseCase, nrDashaboradActions) {
        this.nrDashboradUseCase = nrDashboradUseCase;
        this.nrDashaboradActions = nrDashaboradActions;
    }
    NRDashboardPresenter.prototype.getNRSummary = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nrDashboradUseCase.nrSummary.execute({
                onSuccess: function (nrSummary) {
                    resolve(nrSummary);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    NRDashboardPresenter.prototype.getClientLevel = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nrDashboradUseCase.nrClientLevel.execute({
                onSuccess: function (clientLevel) {
                    resolve(clientLevel);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    NRDashboardPresenter.prototype.getEmployeeData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nrDashboradUseCase.employeeData.execute({
                onSuccess: function (clientLevel) {
                    resolve(clientLevel);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    NRDashboardPresenter.prototype.getLocationData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nrDashboradUseCase.locationData.execute({
                onSuccess: function (clientLevel) {
                    resolve(clientLevel);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    NRDashboardPresenter.prototype.getFinancialYearData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nrDashboradUseCase.financialYear.execute({
                onSuccess: function (clientLevel) {
                    resolve(clientLevel);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    NRDashboardPresenter.prototype.getLobNRData = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nrDashboradUseCase.lobNR.execute({
                onSuccess: function (clientLevel) {
                    resolve(clientLevel);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    NRDashboardPresenter.prototype.getNRData = function (req) {
        var _this = this;
        this.nrDashaboradActions.nrData.hideError("NRData");
        this.nrDashaboradActions.nrData.loader("NRData");
        this.nrDashboradUseCase.nrData.execute({
            onSuccess: function (data) {
                _this.nrDashaboradActions.nrData.updateNRData(data, "NRData");
                _this.nrDashaboradActions.nrData.stopLoader("NRData");
            },
            onError: function (error) {
                _this.nrDashaboradActions.nrData.stopLoader("NRData");
                _this.nrDashaboradActions.nrData.setError({ isOpen: true, error: error }, "NRData");
            },
        }, req);
    };
    NRDashboardPresenter.prototype.getProductData = function (req) {
        var _this = this;
        this.nrDashaboradActions.productData.hideError("ProductData");
        this.nrDashaboradActions.productData.loader("ProductData");
        this.nrDashboradUseCase.productData.execute({
            onSuccess: function (data) {
                _this.nrDashaboradActions.productData.getProductData(data, "ProductData");
                _this.nrDashaboradActions.productData.stopLoader("ProductData");
            },
            onError: function (error) {
                _this.nrDashaboradActions.productData.stopLoader("ProductData");
                _this.nrDashaboradActions.productData.setError({
                    isOpen: true,
                    error: error,
                }, "ProductData");
            },
        }, req);
    };
    NRDashboardPresenter.prototype.getNRHeaderData = function (req) {
        var _this = this;
        this.nrDashaboradActions.nrHeaderData.hideError("NRHeader");
        this.nrDashaboradActions.nrHeaderData.loader("NRHeader");
        this.nrDashboradUseCase.nrHeaderData.execute({
            onSuccess: function (data) {
                _this.nrDashaboradActions.nrHeaderData.getNRHeaderData(data, "NRHeader");
                _this.nrDashaboradActions.nrHeaderData.stopLoader("NRHeader");
            },
            onError: function (error) {
                _this.nrDashaboradActions.nrHeaderData.stopLoader("NRHeader");
                _this.nrDashaboradActions.nrHeaderData.setError({
                    isOpen: true,
                    error: error,
                }, "NRHeader");
            },
        }, req);
    };
    return NRDashboardPresenter;
}());
export default NRDashboardPresenter;
